import useMediaQuery from '@mui/material/useMediaQuery';

const useScreenCustom: Function = (maxWidth: number, minWidth: number): boolean => {
  const maxWidthMatchesRule: string | null = maxWidth ? `(max-width: ${maxWidth}px)` : null;
  const minWidthMatchesRule: string | null = minWidth ? `(min-width: ${minWidth}px)` : null;

  const widthMatchesRules: string[] = [minWidthMatchesRule, maxWidthMatchesRule].filter((
    widthMatchesRule: string | null,
  ): boolean => !!widthMatchesRule) as string[];

  return useMediaQuery(widthMatchesRules.join(' and '));
};

export default useScreenCustom;
